<template>
    <a v-show="showWhatsappIcon" href="https://api.whatsapp.com/send?phone=543434532596&text=Por%20favor%20requiero%20más%20información%20WEB%20Gracias" class="whatsapp-flotado"><i class="mdi mdi-whatsapp"></i></a>
</template>

<style lang="css" scoped>
.whatsapp-flotado {
  background: #25d366;
  color: #fff;
  border-radius: 50%;
  font-size: 30px;
  display: block;
  height: 65px;
  right: 20px;
  padding: 10px;
  position: fixed;
  text-align: center;
  bottom: 15px;
  width: 65px;
  z-index: 1000;
  box-shadow: 0 5px 16px 0 rgba(0, 0, 0, 0.32);
}
.whatsapp-flotado:hover {
  background: #fff;
  color: #25d366;
}
</style>

<script>
export default {
  name: 'WhatsappFlotante',
  data () {
    return {
      showWhatsappIcon: false
    }
  },
  mounted () {
    const componenteVue = this

    var myScrollFunc = function () {
      var y = window.scrollY
      if (y >= 100) {
        componenteVue.showWhatsappIcon = true
      } else {
        componenteVue.showWhatsappIcon = false
      }
    }

    window.addEventListener('scroll', myScrollFunc)
  }
}
</script>
